import genericEmailDomains from './static-data/generic-email-domains';

const isUniqueEmailDomain = (email: string): boolean => {
  const emailDomain = email.match(/@(.+)/)?.[1];

  return !!emailDomain && !genericEmailDomains.includes(emailDomain);
};

export default isUniqueEmailDomain;
